import { STATUS_TYPE } from '../../../enum';

export interface FindShape {
  activeOnly?: boolean;
  limit?: number;
  skip?: number;
  search?: string;
}

export interface GetShape {
  id: string;
}

export interface CreatePatchShape {
  id?: string;
  labelEn: string;
  labelAr: string;
  subLabelEn: string;
  subLabelAr: string;
  code: string;
  descriptionEn: string;
  descriptionAr: string;
  previewUrl: string;
  previewSizeUrl: string;
  // toppingRatio: string;
  size: string;
  price: string;
  discountedPrice: string;
  // toppingPriceRatio: string;
  frameType: string;
  kg: string;
  // slicedImg: string;
  topImg: string;
  frontImg: string;
  // slicedColorImg: string;
  topColorImg: string;
  frontColorImg: string;
  position: string;
  // isOnDemandAllowed: boolean;
  // isNew: boolean;
  activeState: boolean;
}

export interface Shape {
  id: string;
  labelEn: string;
  labelAr: string;
  subLabelEn: string;
  subLabelAr: string;
  code: string;
  descriptionEn: string;
  descriptionAr: string;
  previewUrl: string;
  previewSizeUrl: string;
  // toppingRatio: string;
  size: string;
  price: string;
  discountedPrice: string;
  // toppingPriceRatio: string;
  frameType: string;
  kg: string;
  // slicedImg: string;
  topImg: string;
  frontImg: string;
  // slicedColorImg: string;
  topColorImg: string;
  frontColorImg: string;
  position: string;
  // isOnDemandAllowed: boolean;
  isNew: boolean;
  activeState: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: Shape[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
